import cnLocale from 'element-ui/lib/locale/lang/zh-CN'
const ZH_CN = {
    message: {},
    ...cnLocale
}

export default ZH_CN